module.exports = __webpack_public_path__ + "static/media/saurabh.326ffc85.jpg";